import { I18n } from '@calendly/i18n'
import { nanoid } from 'nanoid'

export const localizeTemplateVariables = (variables) => (variables || []).map((variable) => ({
  ...variable,
  // i18n-tasks-use t('publisher.components.editor.variables.#{variable}')
  localizedName: I18n.t(`publisher.components.editor.variables.${variable.name}`)
}))

const localizeContent = (content, localizedTemplateVariables) => localizedTemplateVariables
  .reduce(
    (acc, { name, localizedName }) => acc.replaceAll(`{{${name}}}`, `{{${localizedName}}}`),
    content || ''
  )

export const delocalizeContent = (content, localizedTemplateVariables) => localizedTemplateVariables
  .reduce(
    (acc, { name, localizedName }) => acc.replaceAll(`{{${localizedName}}}`, `{{${name}}}`),
    content
  )

export const getBodySupportedFormatting = (kind) => (
  // `list` enables both bullet and ordered list toolbar buttons in the RTE.
  ['invitee_invitation', 'invitee_sms_reminder'].includes(kind) ? [] : ['bold', 'italic', 'link', 'list']
)


export const showSubject = (kind) => kind !== 'invitee_sms_reminder'

export const getTimingType = (kind) => (kind === 'invitee_email_follow_up' ? 'post' : 'pre')
export const getTimingsLimit = (kind, eventType) => eventType[`${kind}_limit`] || 0

const buildVariant = (kind, variants, { noReplyEnabled }) => {
  if (kind === 'invitee_email_follow_up' && noReplyEnabled) {
    return variants.no_reply
  }

  return {}
}

export const buildDefaultNotification = (eventType, kind, variantOptions) => {
  const defaultNotification = eventType.default_notifications[kind]

  return {
    ...defaultNotification,
    ...buildVariant(kind, defaultNotification.variants, variantOptions)
  }
}

export const getDefaultFieldValue = (defaultNotification, fieldName) => {
  const localizedSubjectVariables = localizeTemplateVariables(defaultNotification.variables[fieldName])
  return localizeContent(defaultNotification[fieldName], localizedSubjectVariables)
}

export const buildNotification = (eventType, kind) => {
  const defaultNotification = buildDefaultNotification(eventType, kind, { noReplyEnabled: eventType.no_reply_enabled })

  const customNotification = eventType.custom_notifications[kind]

  const notification = {
    ...defaultNotification,
    ...customNotification
  }

  if (notification.timings) {
    notification.timings = notification.timings.map((timing) => ({ id: nanoid(5), ...timing }))
  }

  return {
    ...notification,
    subject: {
      html: localizeContent(
        notification.subject,
        localizeTemplateVariables(defaultNotification.variables.subject)
      )
    },
    body: {
      html: localizeContent(
        notification.body,
        localizeTemplateVariables(defaultNotification.variables.body)
      )
    }
  }
}
